import React from 'react';
import MarkdownPage from '../components/MarkdownPage';

export default function PrivacyPage() {
  return <MarkdownPage src="/privacy.md" />;
}